<template>
  <div class="form-base">
    <v-row>
      <v-col cols="12">
        <DadataOrgField
          label="Наименование, указанное в ЕГРЮЛ"
          outlined
          v-model="v.name.$model"
          :errorMessages="getValidationErrorText(v.name)"
          :suggestions="suggestions"
          field="name"          
          @suggest="onSelect"
        />
      </v-col>

      <v-col cols="6">
        <DadataOrgField
          v-model="v.ogrn.$model"
          :errorMessages="getValidationErrorText(v.ogrn)"
          mask="#############"          
          label="ОГРН - для российского юридического лица"
          outlined
          :suggestions="suggestions"
          field="ogrn"          
          @suggest="onSelect"
        />
      </v-col>
      <v-col cols="6">
        <DadataOrgField
          v-model="v.inn.$model"
          :errorMessages="getValidationErrorText(v.inn)"
          mask="##########"
          label="ИНН - для российского юридического лица"
          outlined
          :suggestions="suggestions"
          field="inn"          
          @suggest="onSelect"
        />
      </v-col>

      <v-col cols="12">
        <AddressStructuredField
          :value="v.address.$model"
          @change="v.address.$model = $event"
          :v="v.address"
          label="Адрес места нахождения, указанный в ЕГРЮЛ"
        />
      </v-col>

      <v-col cols="6">
        <v-text-field
          v-model="v.email.$model"
          :errorMessages="getValidationErrorText(v.email)"
          label="Адрес электронной почты, содержащийся в ЕГРЮЛ"
          outlined
        />
      </v-col>

      <v-col cols="12">
        <TrusteeView
          :v="v.trustee"
          :trustee-status-required="true"
          label="Сведения о представителе юридического лица"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import cloneDeep from 'clone-deep';
import deepmerge from 'deepmerge';
import { maxLength, minLength, required } from 'vuelidate/lib/validators';

import AddressStructuredField, {
  addressValidate
} from '@/components/base/AddressStructuredField';
import {
  getValidationErrorText,
  EMAIL,
  MAX_LENGTH_EMAIL,
  EMOJI,
  INN,
} from '@/utils/validate';
import TrusteeView, {
  trusteeValidate,
  trusteeModel,
} from '@/components/services/elements/TrusteeView';
import  DadataOrgField from '@/components/base/DadataOrgField';

export const organizationModel = {
  name: '',
  address: {},
  ogrn: '',
  inn: '',
  email: '',
  trustee: cloneDeep(trusteeModel),
};

export const getOrganizationValidation = (organization) => ({
  name: {
    required,
    maxLength: maxLength(1000),
    EMOJI,
  },
  address: {
    required,
    ...addressValidate(),
  },
  ogrn: {
    required,
    minLength: minLength(13),
  },
  inn: {
    required,
    minLength: minLength(10),
    INN: INN(10),
  },
  email: {
    required,
    EMAIL,
    maxLength: maxLength(MAX_LENGTH_EMAIL),
  },
  trustee: deepmerge(trusteeValidate(organization.trustee), {
    email: {
      required,
    },
    phone: {
      required,
    },
  }),
});
export default {
  name: 'Organization',
  components: {
    TrusteeView,
    AddressStructuredField,
    DadataOrgField,
  },
  props: {
    v: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    suggestions:  [],
    getValidationErrorText,    
  }),  
  methods: {
    onSelect: function (item) {
      this.suggestions = [item];
      this.v.name.$model = item.name;
      this.v.inn.$model = item.inn;
      this.v.ogrn.$model = item.ogrn;
      this.v.email.$model = item.email;
      this.v.address.$model = {...item.address};
    }
  }
};
</script>
